import AnimateInView from '@atoms/AnimateInView/AnimateInView';
import { IMeta } from '@models/IMeta';
import { IProductCard } from '@models/IProductCard';
import SiteEnum from '@models/enums/SiteEnum';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import ProductCard from '@molecules/ProductCard/ProductCard';
import { fadeInUp } from '@utility/config/animations';
import { motion } from 'motion/react';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly cards: IProductCard[];
  readonly title: string;
  readonly meta?: IMeta;
}

const ProductCarousel = ({ title, cards, meta }: Props) => (
  <AnimateInView>
    <NavigationCarousel
      site={SiteEnum.Deco}
      title={title}
      id={meta?.contentLink ? `product-${meta?.contentLink}` : ''}
      numberOfSlides={cards.length}
      slidesToShowDesktop={4}
      slidesToShowLargeDesktop={4}
    >
      {cards.map((card) => (
        <SwiperSlide
          className="stretch-card tw-h-full"
          key={card.meta?.contentLink || card.productName}
        >
          <motion.div variants={fadeInUp} className="tw-h-full">
            <ProductCard {...card} />
          </motion.div>
        </SwiperSlide>
      ))}
    </NavigationCarousel>
  </AnimateInView>
);

export default ProductCarousel;
